import { Box } from "@vinomofo/components";
import { StarIcon, StarOutlineIcon } from "@vinomofo/icons";
import styled from "styled-components";

interface RatingProps {
  score: number;
  color: string;
  size: string;
}

const StarContainer = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
`;

export const Rating = ({ score, color, size }: RatingProps) => {
  const starRating = Math.round((score / 100) * 5);

  const stars = Array.from({ length: 5 }, (_, index) => ({
    id: index,
    filled: index < starRating,
  }));

  return (
    <StarContainer marginBottom="12px">
      {stars.map(({ id, filled }) =>
        filled ? (
          <StarIcon key={id} color={color} size={size} />
        ) : (
          <StarOutlineIcon key={id} color={color} size={size} />
        )
      )}
    </StarContainer>
  );
};
